import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const MyQuestPage = lazy(
  () => import("@/features/student-view/my-quest/pages/island-list")
);
const StudentAssignmentListPage = lazy(
  () => import("@/features/student-view/my-quest/pages/student-assignment-list")
);
const StudentIslandsSubjectsListPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-management/pages/islands-subjects-list"
    )
);
const StudentViewAssignmentPage = lazy(
  () => import("@/features/student-view/my-quest/pages/view-student-assignment")
);

export const assignmentsRoutes: RouteObject[] = [
  {
    path: "/my-quest",
    element: <MyQuestPage />,
  },
  {
    path: "/my-quest/quest-details/:islandId",
    element: <StudentAssignmentListPage />,
  },
  {
    path: "/my-quest/subjects-list/:islandId",
    element: <StudentIslandsSubjectsListPage />,
  },
  {
    path: "/quest-details/view-assignment/:id",
    element: <StudentViewAssignmentPage />,
  },
];
